import clsx from "clsx";

import type { DeliverableKind } from "../api/types";

interface SheetIconProps {
  /** The kind of deliverable: A, B or C. Left out when the sheet has none. */
  kind?: DeliverableKind | null;
  /** What the sheet is, for screen readers ("P&ID sheet"). */
  label?: string;
  size?: number;
  className?: string;
}

/** A small sheet icon with the letter of its kind of deliverable. */
export function SheetIcon({ kind, label, size = 22, className }: SheetIconProps) {
  const name = label ?? (kind ? `Document of kind ${kind}` : "Document");
  return (
    <svg
      role="img"
      aria-label={kind && label ? `${label}, kind ${kind}` : name}
      className={clsx("sheet-icon", className)}
      data-kind={kind ?? undefined}
      width={size}
      height={Math.round(size * 1.25)}
      viewBox="0 0 24 30"
      focusable="false"
    >
      <path className="sheet-icon__page" d="M3 1.5h12.5L21 7v21.5H3z" />
      <path className="sheet-icon__fold" d="M15.5 1.5V7H21" />
      {kind ? (
        <text className="sheet-icon__letter" x="12" y="22" textAnchor="middle">
          {kind}
        </text>
      ) : (
        <path className="sheet-icon__lines" d="M7 14h10M7 18h10M7 22h6" />
      )}
    </svg>
  );
}
